// @ts-check

import { LOCAL_STORAGE_KEY_PROMOTION_CODE } from '@/core/constants'

export const initPromotionCodeState = () => ({
  promotionCode:
    sessionStorage.getItem(LOCAL_STORAGE_KEY_PROMOTION_CODE) || null
})

/** @type {import('vuex').GetterTree<any, any>} */
export const promotionCodeGetters = {
  getPromotionCode: (state) => {
    return state.promotionCode
  }
}

/** @type {import('vuex').MutationTree<any>} */
export const promotionCodeMutations = {
  setPromotionCode: (state, code) => {
    state.promotionCode = code
    sessionStorage.setItem(LOCAL_STORAGE_KEY_PROMOTION_CODE, code)
  },
  clearPromotionCode: (state) => {
    state.promotionCode = null
    sessionStorage.removeItem(LOCAL_STORAGE_KEY_PROMOTION_CODE)
  }
}

/** @type {import('vuex').ActionTree<any, any>} */
export const promotionCodeActions = {
  updatePromotionCode: ({ commit }, code) => {
    commit('setPromotionCode', code)
  }
}

export const promotionCodeModule = {
  namespaced: true,
  state: initPromotionCodeState,
  getters: promotionCodeGetters,
  mutations: promotionCodeMutations,
  actions: promotionCodeActions
}

export default promotionCodeModule
